import { useState } from "react";
import { Loader2, AlertTriangle } from "lucide-react";

export function ConfirmDialog({ title, message, confirmLabel = "Delete", onConfirm, onCancel }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { await onConfirm(); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/75 backdrop-blur-sm" data-testid="confirm-dialog" onMouseDown={onCancel}>
      <div className="w-full max-w-md bg-[#0A0A0A] border border-[#2A2A2A] shadow-[0_0_60px_rgba(255,77,0,0.15)]" onMouseDown={(e) => e.stopPropagation()}>
        <div className="h-1 bg-[#FF4D00]" />
        <div className="p-7">
          <div className="flex items-center gap-3 mb-3">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-[#EF444420] text-[#EF4444] shrink-0"><AlertTriangle className="w-5 h-5" /></span>
            <h3 className="font-bebas text-2xl tracking-wide">{title}</h3>
          </div>
          <p className="text-sm text-[#A1A1AA] leading-relaxed mb-6">{message}</p>
          <div className="flex justify-end gap-3">
            <button data-testid="confirm-cancel" onClick={onCancel} disabled={busy} className="border border-[#2A2A2A] px-5 py-2.5 text-xs uppercase tracking-[0.1em] text-white hover:bg-[#1A1A1A] transition-colors disabled:opacity-60">Cancel</button>
            <button data-testid="confirm-accept" onClick={run} disabled={busy} className="inline-flex items-center gap-2 bg-[#EF4444] text-white px-5 py-2.5 text-xs uppercase tracking-[0.1em] hover:bg-[#dc2626] transition-colors disabled:opacity-60">
              {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />} {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
